import axios from "axios";
import { saveAs } from "file-saver";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { reportSupervisionTypes } from "redux/reducers/Reports/reportSupervision/types";

const { SET_REPORT_SUPERVISION_FILTERS } = reportSupervisionTypes;

export const getReportSupervisionAction = ({ startDate, endDate, station, token, isPdf = true }) => {
  return async (dispatch) => {
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL_MIGRATIONS}/migrations/report?station=${station.id}&start=${startDate}&end=${endDate}&stationName=${station.name}&pdf=${isPdf}`;
    const fileName = `Reporte_Supervisión_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`;

    dispatch(startRequestComp('loadingReportSupervision'));
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    };
    try {
      const response = await axios(access);
      saveAs(response.data, fileName);
      dispatch(setSnackbar(`${isPdf ? 'PDF' : 'Excel'} Descargado con éxito`, "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportSupervision'));
    }
  };
};

export const setReportSupervisionFilters = (key = "", value) => {
  return {
    type: SET_REPORT_SUPERVISION_FILTERS,
    payload: { value, key }
  };
};
